import '../sass/screen.scss'; // Import SASS for processing

//import SimpleParallax from 'simple-parallax-js/vanilla';
//import Rellax from 'rellax'; // Import Rellax for inertia scrolling

import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import 'slick-carousel/slick/slick.css';           // Slick base styles
import 'slick-carousel/slick/slick-theme.css';     // Optional theme
import 'slick-carousel';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css'; // Required styles

let slickSlider;


jQuery(document).ready(function($) {



    $('#nav-toggle').click(function(){
        $('body').toggleClass('m-toggle');
    });   

    // -- testislider 

    // -- slick slider
    /*
     slickSlider = $('.testimonials__slider');
    if (slickSlider.length) {

        slickSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            arrows: true,
            fade: true,
            prevArrow:"<div class='anchor-action'><i class='fa-solid fa-arrow-left-long'></i></div>",
            nextArrow:"<div class='anchor-action'><i class='fa-solid fa-arrow-right-long'></i></div>",
            dots: false,
            appendArrows: $('.tcontrol-arrows'),
        });

    }
        */



    $('.testimonials__grid').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        arrows: true,
        fade: true,
        prevArrow:'<div class="slide_prev"><svg xmlns="http://www.w3.org/2000/svg" width="102.256" height="27.992" viewBox="0 0 102.256 27.992"><path id="Path_9500" data-name="Path 9500" d="M100.62.26,100.065,0,55.923,20.7a11.149,11.149,0,0,1-9.59,0L2.19,0,1.635.26a3.288,3.288,0,0,0,0,5.685l44.7,20.963a11.15,11.15,0,0,0,9.59,0l44.7-20.963a3.288,3.288,0,0,0,0-5.685" fill="#ed6d04"/></svg></div>',
        nextArrow:'<div class="slide_next"><svg xmlns="http://www.w3.org/2000/svg" width="102.256" height="27.992" viewBox="0 0 102.256 27.992"><path id="Path_9500" data-name="Path 9500" d="M100.62.26,100.065,0,55.923,20.7a11.149,11.149,0,0,1-9.59,0L2.19,0,1.635.26a3.288,3.288,0,0,0,0,5.685l44.7,20.963a11.15,11.15,0,0,0,9.59,0l44.7-20.963a3.288,3.288,0,0,0,0-5.685" fill="#ed6d04"/></svg></div>', 
        dots: false,
     
      });
    

      // -- Logos Slider
      $('.logos').slick({
          speed: 5000,
          autoplay: true,
          autoplaySpeed: 0,
          centerMode: true,
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          initialSlide: 1,
          arrows: false,
          buttons: false
        });
    

})





document.addEventListener('DOMContentLoaded', function () {

    let currentDepth = 0;
    let hasSetup = false;

    function initNav() {

        // -- are we less than 1301px
        if( window.innerWidth > 1300 ) return;


        if (hasSetup) return;
        console.log( "init Nav" );
        setUpBackButtons();
        setUpClickHandlers();
        hasSetup = true;
    }

    const setUpClickHandlers = () => {
        let hasChild = document.querySelectorAll('.menu-item-has-children > a');

        hasChild.forEach(function (item) {
            item.addEventListener('click', function (event) {
                console.log('clicked');
                event.preventDefault();

                let parent = this.parentElement;
                let sub = parent.querySelector('.sub-menu');

                console.log(sub);
                sub.classList.add('active');
            });
        });
    };

    const setUpBackButtons = () => {
        let subs = document.querySelectorAll('.menu-item-has-children ul');

        subs.forEach(function (item) {

        
            let back = document.createElement('li');
            back.classList.add('back');
            back.innerHTML = '<button class="back"><i class="bx bx-chevron-left"></i> Back</button>';
            item.insertBefore(back, item.firstChild);

            
            back.addEventListener('click', function (event) {
                event.preventDefault();
                this.parentElement.classList.remove('active');
            });
        });
    };

    if (window.innerWidth < 1300) {
        initNav();
    }

    // -- need a resize event to check if we need to re-init the nav
    window.addEventListener('resize', function () {
        if (window.innerWidth < 1300 && !hasSetup) {
            initNav();
        }
    });

    // -- get all a tags in .nav if we are below 1300px
    if (window.innerWidth < 1300) {
        let links = document.querySelectorAll('.header .nav a');
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                // -- remove m-toggle class from body
                document.body.classList.remove('m-toggle');
            });
        });
    }

});




// -- [GLOBAL] on reszie get the header height and set it as a css var



const getHeaderHeight = () => {

    const header = document.querySelector('.header');

    // -- set timeout to allow for the header to render

    setTimeout(function() { 
    
        let headerHeight = header.offsetHeight;

        document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');

    }, 1000);

};

document.addEventListener('DOMContentLoaded', function() {

    // -- add a JS class to the body
    document.body.classList.add('js');

    // -- get the header height and assign it as a VAR
    getHeaderHeight();

    window.addEventListener('resize', function() {
            
            getHeaderHeight();
    
    });

});


document.addEventListener('DOMContentLoaded', function () {

    const toggle = document.querySelector('.page-ui__nav-toggle');
    const nav = document.querySelector('.page-ui__nav');
    const catnav = document.querySelector('.cat-nav');

    // ✅ Stop only if toggle is missing OR both nav and catnav are missing
    if (!toggle || (!nav && !catnav)) return;

    toggle.addEventListener('click', function () {

        const expanded = this.getAttribute('aria-expanded') === 'true' || false;

        this.setAttribute('aria-expanded', !expanded);

        if( nav ) {
              nav.classList.toggle('is-open');
        }

        if( catnav ) {
            catnav.classList.toggle('is-open');
        }
      
    });

});



document.addEventListener('DOMContentLoaded', function () {

 const masthead = document.querySelector('.masthead');
  const contentEl = masthead?.querySelector('.masthead__content');
  if (!masthead || !contentEl) return;

  const imgEl =
    masthead.querySelector('picture > img') ||
    masthead.querySelector(':scope > img');
  if (!imgEl) return;

  const cfg = {
    // Image: scale UP
    image: { start: 0.00, end: 0.80, min: 1.00, max: 1.20 },
    // Content: fade OUT
    content: { start: 0.15, end: 0.90, max: 1.00, min: 0.00 }
  };

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const clamp01 = v => Math.max(0, Math.min(1, v));
  const map = (x, a, b, c, d) => c + (d - c) * clamp01(a === b ? 0 : (x - a) / (b - a));

  let running = false;
  let rafId = null;

  const tick = () => {
    const rect = masthead.getBoundingClientRect();
    const h = rect.height || 1;
    const progress = clamp01(-rect.top / h);

    const imgScale = map(progress, cfg.image.start, cfg.image.end, cfg.image.min, cfg.image.max);
    const contentOpacity = map(progress, cfg.content.start, cfg.content.end, cfg.content.max, cfg.content.min);

    masthead.style.setProperty('--img-scale', imgScale.toFixed(4));
    contentEl.style.setProperty('--content-opacity', contentOpacity.toFixed(4));

    if (running) rafId = requestAnimationFrame(tick);
  };

  const io = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
      if (isVisible && !running) {
        running = true;
        cancelAnimationFrame(rafId);
        tick();
      } else if (!isVisible && running) {
        running = false;
        cancelAnimationFrame(rafId);
      }
    },
    { root: null, rootMargin: '50% 0px 50% 0px', threshold: 0 }
  );

  io.observe(masthead);

  window.addEventListener('load', () => {
    masthead.style.setProperty('--img-scale', cfg.image.min.toFixed(4));
    contentEl.style.setProperty('--content-opacity', cfg.content.max.toFixed(4));
    tick();
  }, { passive: true });

  window.addEventListener('resize', () => running && tick(), { passive: true });

});




document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.clipReveal');
  if (!items.length) return;

  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target); // reveal once
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px', // trigger just before fully in view
      threshold: 0
    }
  );

  items.forEach(el => io.observe(el));
})

document.addEventListener('DOMContentLoaded', function () {
  
const headerFigure = document.querySelector('.masthead figure');
  if (!headerFigure) return;

  const onScroll = () => {
    if (window.scrollY > 2) {
      headerFigure.classList.add('scrolled');
      window.removeEventListener('scroll', onScroll);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

});


// -- PhotoSwipe Lightbox
document.addEventListener('DOMContentLoaded', function () {

   const lightbox = new PhotoSwipeLightbox({
    gallery: '#gallery',
    children: 'a',
    pswpModule: PhotoSwipe // 👈 Use static import here
  });

  lightbox.init();
});




// -- If body has a class of header--fixed when we clear .masthead then add a class of header--docked to the .header 
document.addEventListener('DOMContentLoaded', function () {
  
    if (!document.body.classList.contains('header--fixed')) return;

    const masthead = document.querySelector('.masthead');
    const header = document.querySelector('.header');
    if (!masthead || !header) return;

    const onScroll = () => {
      if (window.scrollY > masthead.offsetHeight) {
        header.classList.add('header--docked');
      } else {
        header.classList.remove('header--docked');
      }
    };
  
    window.addEventListener('scroll', onScroll, { passive: true });
  
  });


 var mapStyle = [
    {
        "featureType": "water",
        "stylers": [
            {
                "color": "#0C3A60"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "weight": 6
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#e36d04"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#efe9e4"
            },
            {
                "lightness": -40
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#efe9e4"
            },
            {
                "lightness": -20
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "lightness": 100
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "lightness": -100
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.icon"
    },
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "stylers": [
            {
                "lightness": 20
            },
            {
                "color": "#efe9e4"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "lightness": 100
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "lightness": -100
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "hue": "#e36d04"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "lightness": 100
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
            {
                "hue": "#e36d04"
            },
            {
                "saturation": 58
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#f0e4d3"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#efe9e4"
            },
            {
                "lightness": -25
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#efe9e4"
            },
            {
                "lightness": -10
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    }
];

  // -- Google Map: only initialised on pages that actually have a #map element
  function initMap() {

      const mapEl = document.getElementById('map');
      if (!mapEl) return;

      const lat = parseFloat(mapEl.getAttribute('data-lat'));
      const lng = parseFloat(mapEl.getAttribute('data-lng'));
      if (isNaN(lat) || isNaN(lng)) return;

      const myLatLng = { lat: lat, lng: lng };

      // create a new map and use the custom style
      const map = new google.maps.Map(mapEl, {
          zoom: 16,
          center: myLatLng,
          styles: mapStyle
      });

      const marker = new google.maps.Marker({
          position: myLatLng,
          map: map
      });

  }

  // -- wait for the Maps API to arrive rather than assuming it has loaded after 1s
  document.addEventListener('DOMContentLoaded', function () {

      if (!document.getElementById('map')) return;

      let waited = 0;

      const poll = setInterval(function () {

          if (window.google && window.google.maps) {
              clearInterval(poll);
              initMap();
              return;
          }

          waited += 200;

          if (waited >= 10000) {
              clearInterval(poll);
              console.warn('Google Maps API did not load, map not initialised.');
          }

      }, 200);

  });
